import React from 'react';
import PropTypes from 'prop-types';

import {
    Grid,
    Link,
    MessageBox,
    MessageBoxIcon,
    MessageBoxText,
} from 'yurstrap';

import ErrorHandler from 'helpers/ErrorsHelpers';

const propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
        PropTypes.string,
    ]),
};

const defaultProps = {
    children: [],
};

class GodBuster extends React.Component {

    constructor(props) {
        super(props);
        this.errorHandler = new ErrorHandler();
        window.callGodBuster = this.componentDidCatch.bind(this, new Error('Test error'));
        this.state = {
            hasError: false,
        };
    }

    componentDidMount() {
        this.errorHandler.bindErrorsListeners();
    }

    componentDidCatch(error) {
        this.errorHandler.report(error);
        this.setState({ hasError: true });
    }

    componentWillUnmount() {
        this.errorHandler.unbindErrorsListeners();
    }

    render() {
        const { hasError } = this.state;
        if (hasError) {
            return (
                <Grid size="small" style={{ top: '60px' }}>
                    <MessageBox type="error" className="mt-4">
                        <MessageBoxIcon type="error" />
                        <MessageBoxText className="u-font-size--4">
                            Une erreur inconnue est survenue.
                            Notre équipe technique a été notifiée de ce problème.
                            <br />
                            Nous nous excusons de la gêne occasionnée.
                            <br />
                            <span className="u-font-size--4">
                                <Link
                                    color="error"
                                    className="u-font-weight--bold"
                                    onClick={window.location.reload}
                                >
                                    Cliquez ici
                                </Link>
                                {' pour recharger la page'}
                            </span>
                        </MessageBoxText>
                    </MessageBox>
                </Grid>
            );
        }
        const { children } = this.props;
        return children;
    }

}

GodBuster.propTypes = propTypes;
GodBuster.defaultProps = defaultProps;

export default GodBuster;
